import { createApi } from '@reduxjs/toolkit/query/react'
import type { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query'

import { HTTP_METHODS } from 'common/constants/httpMethodsConstants'
import type { IRequestData } from 'common/interfaces/IRequestResponse'
import type { TableParamsType } from 'common/interfaces/ITable'
import { UtilService } from 'common/services/utilService'
import { baseQuery } from 'common/store/api/fetchBaseQuery'
import { REDUCERS } from 'common/store/reducerConstants'

import type { IDoctor } from 'features/Admin/interfaces/IDoctor'
import type { IStaff } from 'features/Staff/interfaces/IStaff'

const { withPaginationParams } = UtilService

export const adminApi = createApi({
  reducerPath: REDUCERS.ADMIN,
  baseQuery: baseQuery(),
  tagTypes: ['Admin', 'AdminStaff', 'Levels'],
  endpoints: (build: EndpointBuilder<BaseQueryFn, string, string>) => ({
    fetchDoctors: build.query({
      query: (params: TableParamsType) => ({
        url: withPaginationParams('/get-all-doctors', params),
      }),
      transformResponse: (response: IRequestData<IDoctor[]>): IRequestData<IDoctor[]> => ({
        ...response,
      }),
      providesTags: ['Admin'],
    }),
    fetchStaffAdmin: build.query<IRequestData<IStaff[]>, TableParamsType>({
      query: (params: TableParamsType) => ({
        url: withPaginationParams('/get-all-staff', params),
      }),
      providesTags: ['AdminStaff'],
    }),
    loginAsDoctor: build.mutation({
      query: (doctorId) => ({
        url: `/log-in-as-doctor/${doctorId}`,
        method: HTTP_METHODS.POST,
      }),
      invalidatesTags: ['Admin', 'Levels'],
    }),
    logoutAsDoctor: build.mutation({
      query: (old_access_token) => ({
        url: `/log-out-from-another-doctor`,
        method: HTTP_METHODS.POST,
        data: { old_access_token },
      }),
      invalidatesTags: ['Admin'],
    }),
  }),
})

export const {
  useLazyFetchDoctorsQuery,
  useLoginAsDoctorMutation,
  useLogoutAsDoctorMutation,
  useLazyFetchStaffAdminQuery,
} = adminApi
